const MEINVOICE_SYNC_LABEL = {
    invoices: 'Đồng bộ hóa đơn',
    items: 'Đồng bộ hàng hóa',
}

const FUEL_TYPES = {
    GASOLINE: 'Xăng',
    DIESEL: 'Diesel',
};

export { MEINVOICE_SYNC_LABEL, FUEL_TYPES };